import { render, staticRenderFns } from "./BusinessCardForm.vue?vue&type=template&id=5f387e77&scoped=true&lang=pug&"
import script from "./BusinessCardForm.vue?vue&type=script&lang=js&"
export * from "./BusinessCardForm.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCardForm.vue?vue&type=style&index=0&id=5f387e77&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f387e77",
  null
  
)

/* custom blocks */
import block0 from "./BusinessCardForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports